/**
 * HTML data-tracker-* 属性名常量
 */
export const DATA_ATTRS = {
  /** 元素唯一追踪标识 */
  ELE_ID: 'data-tracker-ele-id',
  /** 元素名称 */
  ELE_NAME: 'data-tracker-ele-name',
  /** 元素绑定的参数 */
  ELE_PARAMS: 'data-tracker-ele-params',
  /** 曝光触发方式 */
  EXPOSE_TRIGGER: 'data-tracker-ele-expose-trigger',
  /** 曝光id */
  EXPOSE_ID: 'data-tracker-expose-id',
  /** 页面自定义参数（JSON） */
  PAGE_CUSTOM_PARAMS: 'data-tracker-page-custom-params',
  /** 点击事件场景 */
  CLICK_EVENT_SCENE: 'data-tracker-click-scene',
  /** 
   * 列表项过滤条件（JSON）
   * 根据列表项的属性对接口进行过滤，获取符合条件的列表项
   * 适用于列表渲染场景，注意：字段名必须和接口返回的字段名一致
   * @example {"id": 123, "code": "xxx"}
   */
  LIST_ITEM_FILTER: 'data-tracker-list-item-filter',
} as const

/**
 * 自动曝光扫描默认配置
 */
export const AUTO_EXPOSURE_DEFAULTS = {
  MAX_ELEMENTS: 100,
  // PC 端节流间隔（ms）
  PC_SCROLL_THROTTLE: 200,
  PC_CLICK_DEBOUNCE: 100,
  PC_COOLDOWN: 200,
  // H5 移动端节流间隔（ms）
  MOBILE_SCROLL_THROTTLE: 300,
  MOBILE_CLICK_DEBOUNCE: 150,
  MOBILE_COOLDOWN: 400,
  // 通用
  RESIZE_DEBOUNCE: 500,
  ROUTE_DEBOUNCE: 300,
  MAX_SCANS_PER_PAGE: 1000,
} as const

/**
 * afterClick 默认配置
 */
export const AFTER_CLICK_DEFAULTS = {
  /** 等待上报完成的最大超时时间（ms） */
  TIMEOUT: 5000,
  /** 自动清理的额外缓冲时间（ms） */
  AUTO_CLEANUP_BUFFER: 500,
  /** 响应体最大截断长度（字节） */
  MAX_RESPONSE_SIZE: 2048,
} as const
